/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
  GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  GetApiV1PersonSharedStudentEnrollments401,
  GetApiV1PersonSharedStudentEnrollments500,
} from "../../types/personSharedController/GetApiV1PersonSharedStudentEnrollments.ts";

function getGetApiV1PersonSharedStudentEnrollmentsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/student-enrollments` as const,
  };
  return res;
}

/**
 * @description Busca pelo nome ou e-mail do aluno e retorna as matrículas (CourseRegistration) no formato Key/Value: Key = Id da matrícula, Value = "Nome [Email] Código da Turma". Filtro vazio retorna lista vazia. **(Requer Authorization para autenticação)**
 * @summary Buscar matrículas do aluno por nome ou e-mail (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/student-enrollments}
 */
export async function getApiV1PersonSharedStudentEnrollments(
  params?: GetApiV1PersonSharedStudentEnrollmentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedStudentEnrollmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedStudentEnrollments401
      | GetApiV1PersonSharedStudentEnrollments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedStudentEnrollmentsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
